/* eslint-disable react-hooks/exhaustive-deps */
import { FunctionComponent, useCallback, useMemo, useState } from 'react'
import {
  MdCloudDownload,
  MdLocalOffer,
  MdPlace,
  MdVisibility,
  MdCancel,
  MdCheck,
} from 'react-icons/md'

import { Grid } from '@material-ui/core'
import ICancelTripImpl from 'modules/lotesSolicitados/domain/usecases/CancelTripImpl'
import IEndTripImpl from 'modules/lotesSolicitados/domain/usecases/EndTripImpl'
import Button from 'shared/components/Button'
import Excluir from 'shared/components/Excluir'
import { colors } from 'shared/styles/colors'
import { numberToCurrency } from 'shared/utils/formatters'
import { iconProdutoLote } from 'shared/utils/iconProdutoLote'

import { ILoteCardProps } from './CardComponent.types'
import {
  CardContainer,
  GridContainer,
  Icon,
  IconProduto,
  OcInfoCard,
  Subtitle,
  Title,
  TitleCard,
} from './styles'
import { registerEvent } from 'shared/services/TrackingGAService'
import { EStatusConjunto } from '../../utils/EStatusConjunto'
import { ELockOCMessageTypes } from '../../utils/ELockOCMessage'
import { StatusValidationError } from 'shared/errors/validationError'

const EStatusLoteFila = {
  EmTransito: 1,
  Confirmado: 2,
  NaFila: 3,
  Carregando: 4,
  Entregue: 5,
  Desistiu: 6,
  Embarcado: 7,
  Removido: 8,
  AguardandoAprovacao: 10,
}

function reprovadoGR(statusGR: EStatusConjunto, statusOP: EStatusConjunto) {
  if (
    statusGR === EStatusConjunto.REPROVADO &&
    statusOP === EStatusConjunto.REPROVADO
  ) {
    return true
  }
  if (
    statusGR === EStatusConjunto.REPROVADO &&
    statusOP === EStatusConjunto.AGUARDANDO
  ) {
    return true
  }
  if (
    statusGR === EStatusConjunto.REPROVADO &&
    statusOP === EStatusConjunto.LIBERADO
  ) {
    return true
  }
  return false
}
function semCadencia(statusGR: EStatusConjunto, statusOP: EStatusConjunto) {
  if (
    statusGR === EStatusConjunto.AGUARDANDO &&
    statusOP === EStatusConjunto.REPROVADO
  ) {
    return true
  }
  if (
    statusGR === EStatusConjunto.LIBERADO &&
    statusOP === EStatusConjunto.REPROVADO
  ) {
    return true
  }
  return false
}
function aguardandoValidacao(
  statusGR: EStatusConjunto,
  statusOP: EStatusConjunto,
) {
  if (
    statusGR === EStatusConjunto.LIBERADO &&
    statusOP === EStatusConjunto.AGUARDANDO
  ) {
    return true
  }
  if (
    statusGR === EStatusConjunto.AGUARDANDO &&
    statusOP === EStatusConjunto.LIBERADO
  ) {
    return true
  }
  if (
    statusGR === EStatusConjunto.AGUARDANDO &&
    statusOP === EStatusConjunto.AGUARDANDO
  ) {
    return true
  }
  return false
}

const LoteSolicitadoCard: FunctionComponent<ILoteCardProps> = ({
  lote,
  findByCodigoOcOuLoteSolicitadoId,
  endTrip,
  cancelTrip,
  setLoading,
  setOpen,
  setMessages,
  setOpenModal,
  setLoteSolicitadoId,
  setSmsConfig,
  setTelefone,
  setOpenDrawer,
  setLoteDetalhado,
  setAlertType,
}) => {
  const [openModalDeletar, setOpenModalDeletar] = useState(false)
  const [deletado, setDeletado] = useState(false)

  const isCancelTrip = [
    EStatusLoteFila.EmTransito,
    EStatusLoteFila.Confirmado,
    EStatusLoteFila.NaFila,
    EStatusLoteFila.Carregando,
  ].includes(lote.tmov_lote_conjunto_status_id)

  const isEndTrip = [EStatusLoteFila.Embarcado].includes(
    lote.tmov_lote_conjunto_status_id,
  )

  const txtTypeTrip = isCancelTrip ? 'Cancelar' : isEndTrip ? 'Finalizar' : ''

  const handleOrdemCarregamento = useCallback(async () => {
    registerEvent({
      categoria: 'OC',
      acao: 'Baixar OC ',
      local: 'Tela de Lotes Solicitados',
    })
    setTelefone(lote.usuario?.telefone)

    setLoading(true)
    try {
      const response = await findByCodigoOcOuLoteSolicitadoId.execute({
        lote_solicitado_id: lote.id,
        type: 'url',
        ordem_carregamento_codigo: lote.ordem_carregamento_codigo,
      })

      setLoading(false)

      window.open(response, '_blank')
    } catch (error: any) {
      const msg = error?.statusValidation
      if (error instanceof StatusValidationError && msg) {
        if (!msg.status_OP) {
          if (msg.status_GR === EStatusConjunto.AGUARDANDO) {
            setLoteSolicitadoId(lote.id)
            if (lote.send_sms === null) {
              setAlertType(ELockOCMessageTypes.AGUARDANDO_VALIDACAO)
            } else {
              setSmsConfig(lote.send_sms)
              setAlertType(ELockOCMessageTypes.WAIT_FOR_NOTIFICATION)
            }
          } else if (msg.status_GR === EStatusConjunto.REPROVADO) {
            setAlertType(ELockOCMessageTypes.REPROVADO_GR)
          } else {
            setMessages(
              'Não foi possível gerar a ordem de carregamento, por favor tente novamente em alguns minutos.',
            )
            setOpen(true)
          }
        } else {
          if (reprovadoGR(msg.status_GR, msg.status_OP)) {
            setAlertType(ELockOCMessageTypes.REPROVADO_GR)
          } else if (semCadencia(msg.status_GR, msg.status_OP)) {
            setAlertType(ELockOCMessageTypes.SEM_CADENCIA)
          } else if (aguardandoValidacao(msg.status_GR, msg.status_OP)) {
            setLoteSolicitadoId(lote.id)
            if (lote.send_sms === null) {
              setAlertType(ELockOCMessageTypes.AGUARDANDO_VALIDACAO)
            } else {
              setSmsConfig(lote.send_sms)
              setAlertType(ELockOCMessageTypes.WAIT_FOR_NOTIFICATION)
            }
          } else {
            setMessages(
              'Não foi possível gerar a ordem de carregamento, por favor tente novamente em alguns minutos.',
            )
            setOpen(true)
          }
        }
      } else if (error instanceof Error) {
        setMessages(error.message)
        setOpen(true)
      }

      setLoading(false)
    }
  }, [
    findByCodigoOcOuLoteSolicitadoId,
    lote.id,
    lote.ordem_carregamento_codigo,
    setLoading,
    setLoteSolicitadoId,
    setMessages,
    setOpen,
    setAlertType,
  ])

  const handleActionTrip = useCallback(
    async (fn: IEndTripImpl | ICancelTripImpl, loteId: number) => {
      setLoading(true)
      try {
        await fn.execute(loteId)
        setDeletado(true)
        setOpenModal(true)
        setLoading(false)
      } catch (e: unknown) {
        if (e instanceof Error) {
          setMessages(e.message)
        } else {
          setMessages('Erro ao tentar encerrar a viagem')
        }
        setOpen(true)
        setLoading(false)
      } finally {
        setOpenModalDeletar(false)
      }
    },
    [setLoading, setMessages, setOpen, setOpenModal],
  )

  const getButtonProps = useMemo(() => {
    if (
      [
        EStatusLoteFila.EmTransito,
        EStatusLoteFila.Confirmado,
        EStatusLoteFila.NaFila,
        EStatusLoteFila.Carregando,
        EStatusLoteFila.AguardandoAprovacao,
      ].includes(lote.tmov_lote_conjunto_status_id)
    ) {
      return {
        fn: cancelTrip,
        icon: <MdCancel />,
        value: 'Remover',
        color: colors.red,
      }
    }

    if (
      [EStatusLoteFila.Embarcado].includes(lote.tmov_lote_conjunto_status_id)
    ) {
      return {
        fn: endTrip,
        icon: <MdCheck />,
        value: 'Finalizar',
        color: colors.green,
      }
    }
  }, [lote.tmov_lote_conjunto_status_id, endTrip, cancelTrip])

  return (
    <>
      <CardContainer>
        <Grid container justifyContent="space-between">
          <Grid item xs={12} sm={12} md={5}>
            <Grid container style={{ height: '100%' }}>
              <Grid container>
                <TitleCard>Dados da oferta</TitleCard>
              </Grid>
              <Grid container>
                <Grid item xs={7}>
                  <Grid item xs={12}>
                    <Title>Origem</Title>
                  </Grid>
                  <Grid container alignItems={'center'}>
                    <Icon>
                      <MdPlace fontSize="small" />
                    </Icon>
                    <Subtitle>{lote.origem}</Subtitle>
                  </Grid>
                </Grid>
                <Grid item xs={5}>
                  <Grid item xs={12}>
                    <Title>Valor/ ton</Title>
                  </Grid>
                  <Grid container alignItems={'center'}>
                    <Icon>
                      <MdLocalOffer fontSize="small" />
                    </Icon>
                    <Subtitle>{numberToCurrency(lote.valor)}</Subtitle>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={7}>
                  <Grid item xs={12}>
                    <Title>Destino</Title>
                  </Grid>
                  <Grid container alignItems={'center'}>
                    <Icon>
                      <MdPlace fontSize="small" />
                    </Icon>
                    <Subtitle>{lote.destino}</Subtitle>
                  </Grid>
                </Grid>
                <Grid item xs={5}>
                  <Grid item xs={12}>
                    <Title>Produto</Title>
                  </Grid>
                  <Grid container alignItems={'center'}>
                    <IconProduto src={iconProdutoLote(lote.produto)} />
                    <Subtitle>{lote.produto}</Subtitle>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={5}>
            <Grid container style={{ height: '100%' }}>
              <Grid container>
                <TitleCard>Dados do motorista</TitleCard>
              </Grid>
              <Grid container>
                <Grid item xs={12}>
                  <Title>Motorista</Title>
                </Grid>
                <Grid container alignItems={'center'}>
                  <Subtitle>{lote.conjunto?.motorista?.nome}</Subtitle>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12}>
                  <Title>CNH</Title>
                </Grid>
                <Grid container alignItems={'center'}>
                  <Subtitle>{lote.conjunto?.motorista?.cnh}</Subtitle>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={2}>
            <Grid
              container
              direction="row"
              alignItems={'center'}
              justifyContent={'space-around'}
              style={{ height: '100%' }}
            >
              <Grid item xs={12}>
                <Button
                  aria-label={`btn-visualizar-${lote.id}`}
                  color={colors.orange}
                  style={{ height: 32, width: 122 }}
                  onClick={() => {
                    registerEvent({
                      categoria: 'Detalhes do Lote Solicitado',
                      acao: 'Abriu drawer',
                      local: 'Tela de Lotes Solicitados',
                    })

                    setOpenDrawer(true)
                    setLoteDetalhado(lote)
                  }}
                >
                  <MdVisibility />
                  Visualizar
                </Button>
              </Grid>
              <Grid item xs={12}>
                {[EStatusLoteFila.Removido].includes(
                  lote.tmov_lote_conjunto_status_id ?? 0,
                ) ? (
                  <Grid
                    container
                    direction="row"
                    alignItems={'center'}
                    style={{ height: '100%' }}
                  >
                    <OcInfoCard>O.C cancelada</OcInfoCard>
                  </Grid>
                ) : (
                  <Button
                    aria-label={`btn-baixar-oc-${lote.id}`}
                    style={{ height: 32, width: 122 }}
                    color={colors.lightBlue}
                    onClick={handleOrdemCarregamento}
                  >
                    <MdCloudDownload />
                    Baixar O.C
                  </Button>
                )}
              </Grid>
              {getButtonProps && getButtonProps.value && (
                <Grid item xs={12}>
                  <Button
                    style={{ height: 32, width: 122 }}
                    color={getButtonProps.color}
                    onClick={() => {
                      setOpenModalDeletar(true)
                    }}
                  >
                    {getButtonProps.icon}
                    {getButtonProps.value}
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
        {txtTypeTrip && (
          <Excluir
            openModalDeletar={openModalDeletar}
            onCloseModal={() => {
              setOpenModalDeletar(false)
            }}
            title={`${txtTypeTrip} viagem`}
            subTitle={`Tem certeza que deseja ${txtTypeTrip.toLowerCase()} esta viagem?`}
            deletado={deletado}
            titleDeletado={`Viagem ${txtTypeTrip} !`}
            idSelecionado={undefined}
            onDelete={async () => {
              await handleActionTrip(
                getButtonProps.fn,
                lote.tmov_lote_conjunto_id,
              )
            }}
            buttonLabel={`Sim, ${txtTypeTrip}`}
            buttonColor={txtTypeTrip === 'Finalizar' ? colors.green : undefined}
          />
        )}
      </CardContainer>
    </>
  )
}

export default LoteSolicitadoCard
